const actions = {
  SET_STATE: 'feedback/SET_STATE',
  GET_QUESTIONS: 'feedback/GET_QUESTIONS',
  FEEDBACK_SUBMIT: 'feedback/FEEDBACK_SUBMIT',
}

export default actions
